import { useEffect, useState } from 'react';
import Loader from '../Common/Loader';
import { ContactForm } from '../../Models/ContactForm';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ContactFormListTable from './ContactFormListTable';
import ContactFormApi from '../../Api/ContactFormApi';

export default function ContactFormList() {
  const { id } = useParams();
  const [contactFormData, setContactFormData] = useState<ContactForm[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getContactForms();
  }, []);

  const getContactForms = () => {
    // if (id) {
    try {
      setIsLoading(true);
      return ContactFormApi.getContactFormList()
        .then((res) => {
          setContactFormData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {});
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
    // }
  };

  return (
    <>
      <div className='w-full'>
        <div className='w-full p-4'>
          {isLoading && <Loader />}
          <ContactFormListTable data={contactFormData} />
        </div>
      </div>
    </>
  );
}
